import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import Layout from "../components/layout/Index.vue"
import RouterGuard from './guard'
import NotFound from "@/views/NotFound.vue"
import Nopower from "@/views/Nopower.vue"
// const routes = [
//   {
//     path: '/',
//     component: Layout,
//     meta: { title: '首页' },
//     name:"Home",
//     redirect: '/dashboard',
//     children: [
//       {
//         path: 'dashboard',
//         name: 'Dashboard',
//         meta: { title: '仪表盘' },
//         component: () => import('../views/AboutView.vue')
//       }
//     ]
//   },
//   {
//     path: '/settings',
//     name: 'Settings',
//     meta: { title: '设置' },
//     component: Layout,
//     children: [
//       {
//         path: 'general',
//         name: 'GeneralSettings',
//         meta: { title: '通用设置' },
//         component: () => import('../views/AboutView.vue')
//       },
//       {
//         path: 'security',
//         name: 'SecuritySettings',
//         meta: { title: '安全设置' },
//         component: () => import('../views/HomeView.vue')
//       }
//     ]
//   },
//   {
//     path: '/task',
//     name: 'Task',
//     meta: { title: '任务管理' },
//     component: Layout,
//     children: [
//       {
//         path: 'list',
//         name: 'TaskList',
//         meta: { title: '任务管理' },
//         component: () => import('../views/taskManage/index.vue')
//       },
//       {
//         path: 'result',
//         name: 'TaskResult',
//         meta: { title: '报告管理' },
//         component: () => import('../views/reportManage/index.vue')
//       },
//     ]
//   },
//   {
//     path: '/login',
//     component: () => import('../views/user/login.vue'),
//     meta: { title: '登陆' },
//     name:"Login",
//     children: [
//     ]
//   },
// ];
const routes = [
  {
    path: '/',
    meta: { title: '首页' },
    name: "Home",
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        meta: { title: '首页' },
        component: () => import('../views/HomeView.vue')
      }
    ]
  },
  {
    path: '/date',
    component: Layout,
    meta: { title: '日期管理' },
    name: "Date",
    redirect: '/datelist',
    children: [
      {
        path: '/datelist',
        name: 'DateList',
        meta: { title: '日期管理' },
        component: () => import('../views/dateManage/index.vue')
      },
    ]
  },
  {
    path: '/point',
    component: Layout,
    meta: { title: '点位管理' },
    name: "Point",
    redirect: '/pointlist',
    children: [
      {
        path: '/pointlist',
        name: 'PointList',
        meta: { title: '点位管理' },
        component: () => import('../views/pointManage/index.vue')
      },
    ]
  },
  {
    path: '/apply',
    component: Layout,
    meta: { title: '申请管理' },
    name: "Apply",
    redirect: '/applylist',
    children: [
      {
        path: '/applylist',
        name: 'ApplyList',
        meta: { title: '申请管理' },
        component: () => import('../views/applyManage/index.vue')
      },
    ]
  },
  {
    path: '/user',
    component: Layout,
    meta: { title: '用户管理' },
    name: "User",
    redirect: '/userlist',
    children: [
      {
        path: '/userllist',
        name: 'UserList',
        meta: { title: '用户管理' },
        component: () => import('../views/userManage/index.vue')
      },
    ]
  },
  {
    path: '/login',
    component: () => import('../views/user/login.vue'),
    meta: { title: '登录' },
    name: "Login",
    children: [

    ]
  },
  {
    path: '/nopower',
    name: 'Nopower',
    component: Nopower
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  },
  
]
const router = createRouter({
  history: createWebHistory(),
  routes
});
RouterGuard(router);
export default router;